import date from "date-and-time";
import React from "react";
import { connect } from "react-redux";
import { closeNoMeasurementsWarning } from "../../stores/actions/exportActions";
import { getMeasurements } from "../../stores/actions/measurementsActions";
import { getNodeByIdShort, clearNode, getNodes } from "../../stores/actions/actions";
import { toggleChartType } from "../../stores/actions/actions";
import dashboardStyle from "../../assets/jss/views/dashboardStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NodeGraphCard from "../../components/NodeGraphCard/NodeGraphCard";
import withStyles from "@material-ui/core/styles/withStyles";
import BackArrow from "@material-ui/icons/ArrowBackSharp";
import { NavLink } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Snackbar from '../../../components/Snackbar/Snackbar'
import Loading from "../../components/Loading/Loading";
import Card from "components/Card/Card.js";
import { loaderStyleEmptyCard } from "../../helpers/CustomStyles";
import { getOrderedGraphableNodes } from '../../helpers/nodeSorting';

class NodeDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.days = 30;
    this.to = null;
    this.from = null;
    this.activeTab = 0;
  }

  state = {
    invalidParam: false
  }

  componentWillMount() {
      this.props.clearNode();
      this.loadNodeAndMeasurements();
  }

  componentDidUpdate(prevProps) {
      const prevNodeIdParam = prevProps.match?.params?.nodeId;
      const currentNodeIdParam = this.props.match?.params?.nodeId;
      if (prevNodeIdParam !== currentNodeIdParam) {
          this.loadNodeAndMeasurements();
      }

      const prevSystemId = prevProps.node?.systemId;
      const currentSystemId = this.props.node?.systemId;
      if (currentSystemId && currentSystemId !== prevSystemId) {
          this.props.getNodes([currentSystemId]);
      }
  }

  loadNodeAndMeasurements() {
      const nodeIdParam = this.props.match?.params?.nodeId;
      if (nodeIdParam) {
          const nodeId = parseInt(nodeIdParam);
          if (!isNaN(nodeId)) {
              this.props.getNodeByIdShort(nodeId);
          } else {
              this.setState({ invalidParam: true });
              return;
          }
      }
      const { location, history } = this.props;
      const searchParams = new URLSearchParams(location.search);

      const tab = searchParams.get('tab');
      const isValidTabParam = tab === '0' || tab === '1';
      if (!isValidTabParam) {
          searchParams.set('tab', '0');
      }
      this.activeTab = parseInt(searchParams.get('tab'));
      const from = searchParams.get('from');
      const isValidFromParam = this.isValidDate(from);
      if (!isValidFromParam) {
          let now = new Date();
          let newFrom = date.addMonths(now, -1);
          searchParams.set('from', newFrom.toISOString());
      }
      const to = searchParams.get('to');
      const isValidToParam = this.isValidDate(to);
      if (!isValidToParam) {
          let now = new Date();
          searchParams.set('to', now.toISOString());
      }
      const days = searchParams.get('days');
      const isValidDaysParam = days === '7' || days === '30' || days === '90';
      if (!isValidDaysParam) {
          searchParams.set('days', '30');
      }
      this.props.getMeasurements({
          NodeID: parseInt(this.props.match?.params?.nodeId),
          Start: searchParams.get('from'),
          End: searchParams.get('to')
      });
      history.push(`${location.pathname}?${searchParams.toString()}`);
  }

  componentDidCatch(error, errorInfo) {
    console.error("ERROR__", error, errorInfo)
  }

  isValidDate(dateString) {
    const timestamp = Date.parse(dateString);
    return !isNaN(timestamp) && dateString.trim() !== '';
  }

  componentDidMount() {
    this.closeWarnings();
  }

  closeWarnings = () => {
    const { noMeasurementsWarnings, closeNoMeasurementsWarning } = this.props;
    if (noMeasurementsWarnings.length > 0) {
      noMeasurementsWarnings.forEach(warningId => {
        closeNoMeasurementsWarning(warningId)
      })
    }
  }

  getNodeColor(node) {
    if (!node) {
      node = this.props.node;
    }

    let colors = ["L0", "L1", "L2", "L3", "L4"];
    let ThreatLevelsMap = {
      unknown_or_NA: 0,
      none: 0,
      L1: 1,
      L2: 2,
      L3: 3,
      L4: 4
    };

    return colors[ThreatLevelsMap[node["LatestKnownThreatLevel"]]];
  }

  getPrevNextIds() {
      const { nodes, node } = this.props;
      if (!node || !nodes || !nodes.length) {
          return { prevId: null, nextId: null };
      }
      const orderedIds = getOrderedGraphableNodes(nodes).map(n => n.id);
      const currentIndex = orderedIds.indexOf(node.id);
      if (currentIndex === -1) {
          return { prevId: null, nextId: null };
      }
      return {
          prevId: currentIndex > 0 ? orderedIds[currentIndex - 1] : null,
          nextId: currentIndex < orderedIds.length - 1 ? orderedIds[currentIndex + 1] : null,
      };
  }

  goToDevice = (id) => {
      if (!id) return;
      const { location, history } = this.props;
      history.push(`/devices/${id}/graph${location.search}`);
  };

  render() {
    const {
      classes,
      measurements,
      measurementsLoading,
      node,
      mobileView,
      noMeasurementsWarnings,
      isNodeLoading,
      forbidden,
      getMeasurements
    } = this.props;

    if (forbidden || this.state.invalidParam) {
        return <div  style={{ padding: "10px", ...loaderStyleEmptyCard }}>403</div>;
    }

    if (
      node === undefined
    ) {
      return (
        <GridContainer>
          <Card>
            <div style={loaderStyleEmptyCard}>
              <Loading transform={0.85} height={90} width={70} color="gray" />
            </div>
          </Card>
        </GridContainer>
      );
    } else {
      let renderGraphs = () => {
        const { prevId, nextId } = this.getPrevNextIds();
        return (
          <>
            <NodeGraphCard
              color={this.getNodeColor(node)}
              classes={classes}
              node={node}
              measurements={measurements}
              measurementsLoading={measurementsLoading}
              mobileView={mobileView}
              noMeasurementsWarnings={noMeasurementsWarnings}
              closeNoMeasurementsWarning={this.props.closeNoMeasurementsWarning}
              getMeasurements={getMeasurements}
              activeTab={this.activeTab}
              prevDeviceId={prevId}
              nextDeviceId={nextId}
              goToDevice={this.goToDevice}
            />
            {!mobileView ?
              <Snackbar
                close
                closeNotification={() => this.closeWarnings()}
                color="warning"
                message={'No measurements in this range'}
                open={noMeasurementsWarnings.length > 0}
                place="tc"
                className="no-measurements-warning-graph"
              />
              : ""
            }

          </>
        );
      };

      return (
        <GridContainer>
          {/* Graph Card */}
          <GridItem xs={12}>
            <NavLink to={`/systems/${node.systemId}/dashboard`}>
              <Button
                size="small"
                data-testid="goToDashboard"
              >
                <BackArrow /> Dashboard
              </Button>
            </NavLink>
            {renderGraphs()}
          </GridItem>
        </GridContainer>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    isMapLoading: state.dashboard.isMapLoading,
    measurements: state.dashboard.measurements,
    measurementsLoading: state.dashboard.measurementsLoading,
    node: state.dashboard.node,
    isNodeLoading: state.dashboard.isNodeLoading,
    noMeasurementsWarnings: state.dashboard.noMeasurementsWarnings,
    noMeasurementsWarning: state.dashboard.noMeasurementsWarning,
    mobileView: state.dashboard.mobileView,
    forbidden: state.dashboard.forbidden,
    nodes: state.dashboard.nodes,
  };
};

const actions = {
  getMeasurements,
  getNodeByIdShort,
  clearNode,
  toggleChartType,
  closeNoMeasurementsWarning,
  getNodes
};

const pageWithStyle = withStyles(dashboardStyle)(NodeDetailPage);
export default connect(mapStateToProps, actions)(pageWithStyle);
